/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import { initStickyOffsets } from '../admin/campaignSequenceSticky';
import { initCardMemory } from '../admin/consoleCardMemory';
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@hotwired/turbo-rails'
import '../controllers'
import '../../assets/stylesheets/application.css.scss'
import '../../assets/stylesheets/tailwind.scss'
import ContactGenerator from './contact_generator.js';
import OrderCsvGenerator from './order_csv_generator';
import ExportGenerator from './export_generator';
import TemplateGenerator from './template_generator';
import AwardGenerator from './award_generator';
import Schools from  './schools.js'
import AutoSubmitForm from './auto_submit_form';
import SeasonSelect from './season_select';
import './SortablePackagePoses';

window.Routes = require('routes.js.erb');

// Exposed for the inline script in admin/ec2_processor/show.html.erb, which is
// plain ERB + vanilla JS (no pack of its own). Kept as a module so the rule has
// exactly one definition and a Jest test, instead of being retyped in the view.
window.skipCompletedHonored = require('../utils/skipCompletedHonored').default;

// Exposed for the inline editor in admin/print_reviews/_editor.html.erb (plain
// ERB + vanilla JS). The formula must match the EC2 render exactly, so it lives
// in one tested module rather than in the view.
window.poseAdjustmentToneCurve = require('../utils/poseAdjustmentToneCurve').default;

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);

$(document).ready(() => {
  let $contactContainer = $('#campaign-contact-container');

  if ($contactContainer.length) {
    let contactGenerator = new ContactGenerator({
      $container: $contactContainer,
      exportId: $contactContainer.data('export-id')
    });

    contactGenerator.init();
  }

  let $ordersContainer = $('#order-csv-container');

  if ($ordersContainer.length) {
    let orderCsvGenerator = new OrderCsvGenerator({
      $container: $ordersContainer,
      exportId: $ordersContainer.data('export-id')
    });

    orderCsvGenerator.init();
  }

  let $exportContainer = $('#export-csv-container');

  if ($exportContainer.length) {
    let exportContainer = new ExportGenerator({
      $container: $exportContainer,
      exportId: $exportContainer.data('export-id')
    });

    exportContainer.init();
  }

  let $templateContainer = $('#template-container');

  if ($templateContainer.length) {
    let templateContainer = new TemplateGenerator({
      $container: $templateContainer,
      exportId: $templateContainer.data('export-id'),
      templateId: $templateContainer.data('template-id'),
      pollUrl: $templateContainer.data('url')
    });

    templateContainer.init();
  }

  let $awardContainer = $('#award-container');

  if ($awardContainer.length) {
    let awardContainer = new AwardGenerator({
      $container: $awardContainer,
      exportId: $awardContainer.data('export-id'),
      exportListId: $awardContainer.data('export-list-id')
    });

    awardContainer.init();
  }

  // Console cards: restore whichever sections this person left open, THEN park
  // the column headers under the sticky track head. Memory first, so the sticky
  // offsets are measured against the state the page will actually settle in
  // rather than against a card that is about to close. Both no-op on every
  // other page.
  initCardMemory();
  initStickyOffsets();

  let $autoSubmitForms = $('.auto-submit');

  $autoSubmitForms.each((i, form) => {
    let autoSubmitForm = new AutoSubmitForm({
      form: form
    });

    autoSubmitForm.init();
  });


  const $schoolsButtonGroup = $('#schoolsButtonGroup');

  if ($schoolsButtonGroup.length) {
    new Schools
  }

  let $orderEditContainer = $('.order-edit-container');

  $orderEditContainer.each((i, container) => {
    let orderEditContainer = new SeasonSelect({
      container: container
    });

    orderEditContainer.init();
  });

});
